// extracted by mini-css-extract-plugin
module.exports = {"firstRow":"HQ"};